import { Component, OnInit } from '@angular/core';
import { Subscription,Observable, throwError} from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpEventType  } from '@angular/common/http';
import { DatePipe,DecimalPipe,PercentPipe, JsonPipe } from '@angular/common';
import { catchError } from 'rxjs/operators'
import { FAQService } from "../services/faq.service";
import { AccountFilterService } from "../services/accountfilter.service";
import { AccountService } from '../services/account.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { UserAdminComponent } from './user-admin/user-admin.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  public groups = [];
  private accountFilter$: Subscription;
  private subRegions = [];
  DisplayLogos = false;
  AccountsDef:any = {
    title:"Account",
    tableName:"accounts",
    pagedOn:true,
    filterOn:true,
    sortOn:true,

    fields:[
      { name: "id",
        label: "Id",
        type: "string",
        width: "60px",
        readonly : true
      },
      { name: "name",
        label: "Name",
        type: "string",
        width: "180px",
        isRequired : true

      },
      { name: "accountID",
        label: "Account ID",
        type: "string",
        width: "60px",
        isRequired : true
      },
      {
        name: "parentid",
        label: "Estate Maps Parent",
        type: "dropdown",
        values: [],
        displayname: "parentname"
      },
      { name: "restricted",
      label: "Restricted",
      type: "dropdown",
      align: "center",
      values: ["","Yes"]
    },

    { name: "logo",
      label: "Logo",
      type: "dropdown",
      align: "left",
      logo:"show"
    },

      { name: "code",
      label: "Client Id",
      type: "string",
      width: "60px",
      isRequired:true,
    },
      { name: "short",
        label: "Short Name",
        type: "string",
        align: "left"
      },
      { name: "financialsheet",
        label: "Financial Sheet",
        type: "string"
      },
      { name: "sfdcglobalname",
        label: "SFDC Global Account",
        type: "string"
      },
      { name: "sfdcglobalid",
        label: "SFDC Global Id",
        type: "string",
        width: "60px",
        isRequired : true
      },
      { name: "region",
        label: "Estate Maps Region",
        type: "dropdown",
        // values: ["AMS","ASIA","ANZ","NCE","SE","UKIIMEA"],
        values: ["AMS","APAC","EMEA"],
        isRequired : true,
        child: "salesOrgL2",
      },
      {
        name: "salesOrgL2",
        label: "Sales Org L2",
        type: "dropdown",
        values: [],
        isRequired : true,
        parent: "region",
      },
      { name: "bdmname",
        label: "BDM Name",
        type: "string"
      },
      {
        name: "clientclass",
        label: "Client Class",
        type: "dropdown",
        values: ["Platinum","Emerging Platinum","Gold","Rest of Business"]
      },
      { name: "casesafeid",
        label: "Case Safe Id",
        type: "string",
        width: "60px",
        isRequired : true
      },
      { name: "isdeliverylead",
      label: "Is Delivery Lead",
      type: "dropdown",
      align: "center",
      values: [{value:true,label:"Yes"},{value:false,label:"No"}]
    },
    { name: "isdeleted",
      label: "Is Deleted",
      type: "string",
      width: "60px",
      readonly : true
    },
      { name: "created",
      label: "Created",
      type: "datetime",
      align: "center",
      width: "80px",
      readonly : true
    },{ name: "createdby",
    label: "Created By",
    type: "string",
    align: "center",
    width: "80px",
    readonly : true
  },{ name: "entitylastchanged",
  label: "Last Modified",
  type: "datetime",
  align: "center",
  width: "80px",
  readonly : true
}
    ]
  }

  ActionLogDef:any = {
    title:"Action Log",
    tableName:"ActionLog",
    readOnly:true,
    pagedOn:true,
    filterOn:true,
    sortOn:true,

    fields:[
      { name: "id",
        label: "Id",
        type: "string",
        width: "60px",
        readonly : true
      },
      { name: "username",
        label: "User Name",
        type: "string",
        readonly : true
      },
      { name: "action",
        label: "Action",
        type: "string",
        readonly : true
      },
      { name: "result",
        label: "Result",
        type: "string",
        readonly : true
      },

    { name: "session",
    label: "Extra Info 1",
    type: "string",
    readonly : true
    },
    { name: "browser",
    label: "Extra Info 2",
    type: "string",
    readonly : true
  },
      { name: "started",
        label: "Start",
        type: "datetime",
        align: "center",
        width: "80px",
        readonly : true
      },
      { name: "ended",
        label: "End",
        type: "datetime",
        align: "center",
        width: "80px",
        readonly : true
      }
    ]
  }

  FaqsDef:any = {
    title:"FAQs",
    tableName:"faqs",
    pagedOn:true,
    filterOn:true,
    sortOn:true,
    fields:[
      { name: "id",
        label: "Id",
        type: "string",
        readonly : true
      },
     /*  { name: "class",
        label: "Class",
        type: "dropdown",
        values: ["FAQ","User Guide","Release Notes"]
      }, */
      { name: "classid",
        label: "Category",
        type: "dropdown",
        values: [{value:1,label:"FAQ"},{value:2,label:"Release Notes"},{value:3,label:"User Guides"}],
        isRequired : true,
        child: "groupid",
        displayname: "classname"
      },
      { name: "groupid",
        label: "Group",
        type: "dropdown",
        values: [],
        isRequired : true,
        parent: "classid",
        displayname: "groupname"
      },
      { name: "question",
        label: "Question",
        type: "string",
      },
      { name: "questionorder",
        label: "QuestionOrder",
        type: "string",
      },
     // { name: "answer",
      //  label: "Answer",
      //  type: "string",
    //  },
      { name: "answer",
        label: "Answer",
        type: "string",
      },
      { name: "flag",
      label: "Hot Topics",
      type: "dropdown",
      align: "center",
      values: ["","Yes"]
      },
      { name: "createdby",
        label: "Created By",
        type: "string",
        align: "center",
        readonly : true
      },
      { name: "created",
        label: "Created",
        type: "datetime",
        align: "center",
        readonly : true
      },
    ]
  }

  TestData = "[data should appear here]";

  // Upload stuff
  public progress: number;
  public isLoading=false;
  public message: string;
  private accountsData$: Subscription;
  accountsData:any={
    data:[]
  };

  constructor(private http: HttpClient,
    public decPipe:DecimalPipe,
    public dialog: MatDialog,
    private faqService: FAQService,
    private accountFilterService: AccountFilterService,
    public accountService: AccountService,
    ) { }

  ngOnInit(): void {
    this.accountService.resetAccounts();
    this.faqService.loadGroups();
    this.faqService.groups$.subscribe((responsedata:any) => {
      if(responsedata!=null){
        if(responsedata.loading){
          this.isLoading = true;
        } else {
          this.isLoading = false;
          if(responsedata["data"].length>0){
            let tmp = [];
            responsedata["data"].forEach(x => {
              tmp.push({
                'value': x.groupid,
                'label': x.groupname,
                'parentId': x.classid,
                'parentName': x.classname
              });
            });
            this.groups = tmp;
            this.FaqsDef.fields.forEach(x => {
              if(x.name == "groupid"){
                x.values = this.groups;
              }
            });
          }
        }
      }
    });

    this.accountFilterService.loadAccountsFiltering('regions');
    this.accountFilter$ = this.accountFilterService.accountFilter$.subscribe((res: any) => {
      if(res){
        const { loading, type, data } = res;
        if(!loading && type === 'regions'){
          const regions = JSON.parse(JSON.stringify(data));
          let subRegions = [];
          regions.forEach(itm => {
            if (itm.subregions) {
              const subregions = JSON.parse(itm.subregions);
              if (Array.isArray(subregions)) {
                subregions.forEach(sr => {
                  subRegions.push({
                    value: sr.name,
                    label: sr.name,
                    parentId: itm.name,
                    parentName: itm.name
                  });
                });
              }
            }
          });
          this.subRegions = subRegions;
          this.AccountsDef.fields.forEach(itm => {
            if(itm.name === 'salesOrgL2'){
              itm.values = this.subRegions;
            }
          });
        }
      }
    });

    // wire up the accounts and load them
    this.accountsData$ = this.accountService.accounts$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(!responsedata.loading) {
            this.accountsData = responsedata.data;
            let parentAccounts = [];
            this.accountsData.forEach(account => {
              if(!account.parentid&&account.isdeleted===false){
                parentAccounts.push({
                  value:account.id,label:account.name
                });
              }
            })
            this.AccountsDef.fields.forEach(itm => {
              if(itm.name === 'parentid'){
                itm.values = parentAccounts;
              }
            });
          }
        }
      }
    );
    this.accountService.loadAccounts();
  }

  ngOnDestroy(): void {
    this.accountFilter$.unsubscribe();
    this.accountService.resetAccounts();
  }

  testBDM(){

    this.TestData = "getting data ..."

    this.http.get('/api/data/testbdmdata').subscribe(
      (response: any) => {

        if(Array.isArray(response["data"])){

          let tablestring = "<table><tr><th>Client Name</th><th>Client Id</th><th>Industry</th><th>Fiscal Year</th><th>Revenue</th></td>";

          response["data"].forEach(x => {
            tablestring += "<tr>"
            tablestring += "<td>" + x["dim Client[ClientName]"] + "</td>"
            tablestring += "<td>" + x["dim Client[ClientID]"] + "</td>"
            tablestring += "<td>" + x["dim Client[ClientIndustry]"] + "</td>"
            tablestring += "<td>" + x["[v_CurrentFiscalYear]"] + "</td>"
            // tablestring += "<td align='right'>" + this.decPipe.transform(x["[v_Revenue]"], "1.0-0") + "</td>"
            tablestring += "</tr>"
          });

          tablestring + "</table>"

          this.TestData = tablestring;

        } else {
          this.TestData = JSON.stringify(response)
        }


      }, (error: any) => {
        console.log('unable to get menus');
      }
    )
  }
  selectedTabChange(event){
    console.log(event)
    if(event == 2){
      this.DisplayLogos = true
    }
  }

  public uploadFile = (files) => {
    if (files.length == 0) {
      return;
    }

    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.isLoading = true;

    this.http.post('/api/data/uploadexceldata', formData, {reportProgress: true, observe: 'events'})
      .pipe(catchError(err => {
        // console.log(JSON.stringify(err));
        this.message = err.error["message"].replace(/\|/g,"</br>");
        this.isLoading = false;
        return throwError(err);
      })

      )
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.message = event.body["message"].replace(/\|/g,"</br>");
          this.isLoading = false;
        }
      })
  }

  public uploadUserFile = (files) => {
    if (files.length == 0) {
      return;
    }

    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.isLoading = true;

    this.http.post('/api/data/uploaduserdata', formData, {reportProgress: true, observe: 'events'})
      .pipe(catchError(err => {
        // console.log(JSON.stringify(err));
        this.message = err.error["message"].replace(/\|/g,"</br>");
        this.isLoading = false;
        return throwError(err);
      })

      )
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.message = event.body["message"].replace(/\|/g,"</br>");
          this.isLoading = false;
        }
      })
  }


  public editUser(data){

      // "this" is avaiable in this["context"]
      let newdata = this["context"].deepCopy(data);

      let tableEdit = {
        tableDef: this["context"].UsersDef,
        data: newdata
      }

      let dialogRef = this["context"].dialog.open(UserAdminComponent, {
        height: '650px',
        width: '700px',
        data: tableEdit
      });

      dialogRef.afterClosed().subscribe(result => {

        if(result=="cancel"){

        } else if(result=="delete"){

          // delete from the database
          //this.deleteData(newdata)

        } else if(result!=undefined){

          // save to the database
          // this.updateData(result)

        }
      })

  }

  public exportEntityData(){
    window.location.href = '/api/excel/exportAllEntity'
  }

    // deep copy of Object
    public deepCopy(obj) {
      return Object.keys(obj).reduce((v, d) => Object.assign(v, {
        [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
      }), {});
    }



}
